var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"box",staticClass:"mbo-fit"},[_c('span',{ref:"text",staticClass:"mbo-fit__text",style:({fontSize: _vm.size + 'px'})},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }